var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"bottom-content",class:{ 'wihout-link': !_vm.href },attrs:{"href":_vm.href,"target":"_blank"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }